import { ISavedStateComment } from '@shared/user-state/comments/SavedStateCommentsService';

/*
 * Displays page state comment drawings inside as single fullscreen div with multiple css backgrounds with scaling
 * Not perfect mostly because of scaling, this is the first method we used
 */
export class DrawingsDisplayCss implements IDrawingsDisplay {
    public enabled = true;
    private comments: ISavedStateComment[] = [];

    destroy = () => {
        const wrapper = document.getElementById('screenshot-drawings');
        wrapper.style.backgroundImage = '';
    }

    drawDrawings = () => {
        if (!this.enabled) {
            this.comments.forEach(c => c.canvasVisible = false);
        }

        let wrapper = document.getElementById('screenshot-drawings');
        if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.id = 'screenshot-drawings';
            wrapper.style.zIndex = '2';
            document.getElementById('map-canvas-wrapper').appendChild(wrapper);
        }

        wrapper.style.backgroundImage = this.comments
            .filter(c => !!c.canvas && c.canvasVisible)
            .filter(c => !c.lat) // can't display drawings with coordinates
            .map(c => 'url(' + c.canvas + ')')
            .join(',');
    };

    setComments(value: ISavedStateComment[]) {
        this.comments = value;
    }

    hideDrawings = () => {
        this.comments.forEach(c => c.canvasVisible = false);
        this.drawDrawings();
    };

    hideComment(id: number) {
        this.setCommentVisible(id, false);
    }

    showComment(id: number) {
        this.setCommentVisible(id, true);
    }

    private setCommentVisible = (id: number, state: boolean) => {
        if (!this.enabled) return;

        const comment = this.comments.find(c => c.id === id);
        if (!comment) {
            console.warn('no comment with id found', id);
            return;
        }

        comment.canvasVisible = state;
        this.drawDrawings();
    };
}
